import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { Logger, GlobalInfoService } from '@app/core';
import {
  ButtonsModalTable,
  CategoriaReporte,
  BaseControl,
  ConfirmComponent,
  ModalTableComponent,
} from '@app/shared';
import { ManagementReportsDataService } from './shared/management-reports.data.service';
import { ManagementReportsFormService } from './shared/management-reports.form.service';
import { ManagementReportsComponentConfig } from './shared/management-reports.config.service';
import { Subject } from 'rxjs';

const log = new Logger('ManagementReportsComponent');

@Component({
  selector: 'iw-management-reports',
  templateUrl: './management-reports.component.html',
  styleUrls: ['./management-reports.component.scss'],
  providers: [
    ManagementReportsDataService,
    ManagementReportsFormService
  ]
})
export class ManagementReportsComponent implements OnInit, OnDestroy {

  // Cadena que indica la accion a relaizar en el formulario
  actionForm = '';
  // Pregunta de la modal
  question = '';
  // Pregunta de la modal de acciones de la tabla
  questionTable = '¿Que accion desea realizar para el registro seleccionado?';
  // Define cuando mostrar el formulario
  openForm = false;
  // Define cuando mostrar el componente de reportes
  openReports = false;
  // Define cuando mostrar el formulario
  formEdit = false;
  // Contiene el registro de categoria seleccionado
  rowSelect: CategoriaReporte;
  // Configuracion de la tabla
  settings = {};
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // Contiene los botones que apareceran en la modal de la tabla
  buttons: Array<ButtonsModalTable> = [
    {label: 'Modificar', class: 'btn-warning', value: 'update'},
    {label: 'Eliminar', class: 'btn-danger', value: 'delete'},
    {label: 'Ver reportes', class: 'btn-info', value: 'reports'},
  ];
  // Contiene los controles de el formulario
  controls: BaseControl<any>[] = [];
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;
  // Referencia al componente de el modal de acciones de la tabla
  @ViewChild('modalTable') private modalTable: ModalTableComponent;

  constructor(
    private mrds: ManagementReportsDataService,
    private mrfs: ManagementReportsFormService,
    private gis: GlobalInfoService,
  ) { }

  ngOnInit() {
    // se setea el titulo de la vista actual
    this.gis.set({ title: 'Gestión de reportes' });
    // Se inicia la configuracion de la tabla
    const configTable = new ManagementReportsComponentConfig();
    this.settings = configTable.settings;
    this.loadCategorys();
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Consulta las categorias de reportes del sistema
   *
   * @memberof ManagementReportsComponent
   */
  loadCategorys() {
    this.mrds.getCategoryReport().subscribe(categorys => this.sourceData = new LocalDataSource(categorys));
  }

  /**
   * Controla la acciones a hacer con los registros en la tabla de categorias
   *
   * @param {('clickTable' | 'add' | 'update' | 'delete' | 'reports' | 'close')} [action='add']
   * @param {*} [data]
   * @memberof ManagementReportsComponent
   */
  defineAction(action: 'clickTable' | 'add' | 'update' | 'delete' | 'reports' | 'close' = 'add', data?: any) {
    switch (action) {
      case 'update':
        this.openForm = true;
        this.formEdit = true;
        this.actionForm = 'Modificar';
        this.controls = this.mrfs.getFormCategory(this.rowSelect);
        break;
      case 'delete':
        setTimeout(() => {
          this.question = '¿Realmente desea eliminar la categoría?';
          this.confirm.open();
        }, 500);
        break;
      case 'close':
        this.actionForm = '';
        this.openForm = false;
        this.formEdit = false;
        this.openReports = false;
        this.rowSelect = null;
        this.controls = [];
        break;
      case 'clickTable':
        this.rowSelect = data.data;
        this.modalTable.openModal();
        break;
      case 'reports':
        this.openReports = true;
        break;
      default:
        this.openForm = true;
        this.formEdit = false;
        this.actionForm = 'Agregar';
        this.controls = this.mrfs.getFormCategory();
        break;
    }
  }

  /**
   * Controla las acciones en la modal de confirmaciones
   *
   * @param {boolean} resp
   * @memberof ManagementReportsComponent
   */
  actionComfirm(resp: boolean) {
    if (resp) {
      this.deleteCategory();
    }
  }

  /**
   * Guarda o edita una categoria
   *
   * @param {*} data
   * @memberof ManagementReportsComponent
   */
  sended(data: any) {
    const category: CategoriaReporte = {
      nombre: data.txtNombre,
      descripcion: data.txtDescripcion
    };
    if (this.formEdit) {
      this.mrds.updateCategoryReport(category, this.rowSelect.id).subscribe(resp => {
        if (resp) {
          this.loadCategorys();
          this.defineAction('close');
        }
      });
    } else {
      this.mrds.addCategoryReport(category).subscribe(resp => {
        if (resp) {
          this.loadCategorys();
          this.defineAction('close');
        }
      });
    }
  }

  /**
   * Elimina la categoria seleccionada
   *
   * @private
   * @memberof ManagementReportsComponent
   */
  private deleteCategory() {
    if (this.rowSelect && this.rowSelect.id) {
      this.mrds.deleteCategoryReport(this.rowSelect.id).subscribe(resp => {
        if (resp) {
          this.loadCategorys();
          this.defineAction('close');
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/management-reports/management-reports.component.ts